import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { DATE_FORMAT } from "../../config/constants";

dayjs.extend(utc);
dayjs.extend(utc);
dayjs.extend(timezone);
const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export {};

declare global {
  interface String {
    toDate(noUTC?: "noUTC"): string;
    toShortDate(noUTC?: "noUTC"): string;
    toDateAndTime(noUTC?: "noUTC"): string;
    toTime(noUTC?: "noUTC"): string;
    toUTCDateTime(dayTime: "start" | "end", noUTC?: "noUTC"): string;
    toInputDate(noUTC?: "noUTC"): Dayjs | undefined;
    /**
     * Converts a UTC datetime string to a local ISO string
     * @returns {string} The local ISO string
     */
    toLocalISOString(): string;
    /**
     * Takes a UTC datetime and assumes it's in the user's timezone and converts it to UTC timezone string
     * @returns {string} The UTC datetime string
     */
    utcAsLocalToUTC(): string;
  }
}

String.prototype.toDate = function (noUTC?: "noUTC"): string {
  try {
    const dateAndTimeToUse =
      noUTC || this.toString()?.endsWith("Z")
        ? this.toString()
        : `${this.toString()}Z`;
    return dayjs(dateAndTimeToUse).format(DATE_FORMAT.displayYearDateFormat);
  } catch (error) {
    return "";
  }
};

String.prototype.toLocalISOString = function (): string {
  try {
    const localTime = dayjs.utc(this.toString()).tz(userTimeZone);
    return localTime.format("YYYY-MM-DDTHH:mm:ss.SSS");
  } catch {
    return "";
  }
};

String.prototype.utcAsLocalToUTC = function (): string {
  try {
    // Parse the string literally
    const localTime = dayjs(this.toString());

    // Get system timezone offset in minutes (negative if ahead of UTC)
    const offsetMinutes = new Date().getTimezoneOffset();

    // Adjust the time by offset to get real UTC
    const realUTC = localTime.add(offsetMinutes, "minute").utc();

    // Return ISO UTC string with Z
    return realUTC.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  } catch (err) {
    console.error("Failed to convert local to UTC:", err);
    return "";
  }
};

String.prototype.toShortDate = function (noUTC?: "noUTC"): string {
  try {
    const dateAndTimeToUse =
      noUTC || this.toString()?.endsWith("Z")
        ? this.toString()
        : `${this.toString()}Z`;

    const formattedDate = dayjs(dateAndTimeToUse).format(
      DATE_FORMAT.toShortDate
    );

    return formattedDate;
  } catch (error) {
    return "";
  }
};

String.prototype.toDateAndTime = function (noUTC?: "noUTC"): string {
  try {
    const dateAndTimeToUse =
      noUTC || this.toString()?.endsWith("Z")
        ? this.toString()
        : `${this.toString()}Z`;

    return dayjs(dateAndTimeToUse).format(DATE_FORMAT.toShortDate);
  } catch (error) {
    return "";
  }
};
String.prototype.toDateAndTime = function (noUTC?: "noUTC"): string {
  try {
    const dateAndTimeToUse =
      noUTC || this.toString()?.endsWith("Z")
        ? this.toString()
        : `${this.toString()}Z`;

    const formattedDate = dayjs(dateAndTimeToUse).format(
      DATE_FORMAT.toShortDate
    );

    const formattedTime = dayjs(dateAndTimeToUse).format(DATE_FORMAT.amPmclock);
    return `${formattedDate} - ${formattedTime}`;
  } catch (error) {
    return "";
  }
};

String.prototype.toTime = function (noUTC?: "noUTC"): string {
  try {
    const dateAndTimeToUse =
      noUTC || this.toString()?.endsWith("Z")
        ? this.toString()
        : `${this.toString()}Z`;

    return dayjs(dateAndTimeToUse).format(DATE_FORMAT.clock);
  } catch (error) {
    return "";
  }
};

// converts date to UTC start of the day
String.prototype.toUTCDateTime = function (dayTime, noUTC?: "noUTC"): string {
  try {
    const dateToString = this.toString();

    let dayjsDate;
    if (noUTC) {
      dayjsDate = dayjs(dateToString);
    } else {
      const dateWithZ = dateToString.endsWith("Z")
        ? dateToString
        : `${dateToString}Z`;
      dayjsDate = dayjs.utc(dateWithZ);
    }

    return (function () {
      if (dayTime === "start") return dayjsDate.startOf("day").toISOString();
      return dayjsDate.endOf("day").toISOString();
    })();
  } catch (error) {
    return "";
  }
};

String.prototype.toInputDate = function (noUTC?: "noUTC"): Dayjs | undefined {
  try {
    const date = this.toString();
    if (!date) return undefined;

    if (noUTC) {
      return dayjs(date);
    }

    return date.endsWith("Z") || date.endsWith("z")
      ? dayjs(date)
      : dayjs(`${date}Z`);
  } catch (error) {
    return undefined;
  }
};

String.prototype.toInputDate = function (): Dayjs | undefined {
  try {
    const date = this.toString();
    if (!date) return undefined;
    return date.endsWith("Z") || date.endsWith("z")
      ? dayjs(date)
      : dayjs(`${date}Z`);
  } catch (error) {
    return undefined;
  }
};
